<template>
 <!-- SCRM管理 我的商机 -->
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--添加按钮-->
    <add-btn v-hasPermi="['scrm:bo:add']" @add="handleAddBo()"></add-btn>
    <!--商机搜索筛选框-->
    <search-bo :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <van-tabs v-model="active" @change="handleClick" :ellipsis="false" class="tab">
      <van-tab title="新建" :badge="boCount.xjCount != 0?boCount.xjCount:''"></van-tab>
      <van-tab title="签署中" :badge="boCount.qszCount != 0?boCount.qszCount:''"></van-tab>
      <van-tab title="成功" :badge="boCount.cgCount != 0?boCount.cgCount:''"></van-tab>
      <van-tab title="关注" :badge="boCount.gzCount != 0?boCount.gzCount:''"></van-tab>
    </van-tabs>
    <empty-component v-if="isEmpty" />
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['scrm:bo:list']" @load="onLoad" v-if="list.length > 0">
      <!-- <total-component :totalValue="total" /> -->
      <list-bo-item @todetail="toCustBlueDetails" :listData="list" :dictOptions="dictOptions"/>
    </van-list>
    <dialog-add :show='add_show' :isAdd='true' @handleAddBoCancel='handleAddBoCancel' @beforeClose='addBoBeforeClose' ></dialog-add>
  </div>
</template>

<script>
import { listBo, listStar, getBusinessCount } from '@/api/scrm/mycust'
import { areaList } from '@vant/area-data'
import ListBoItem from '../component/ListBoItem.vue'
import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchBo from '../component/SearchBo.vue'
// import TotalComponent from '@/components/common/Total'
import DialogAdd from '../component/DialogAddBo.vue'
import EmptyComponent from '@/components/common/Empty'
import AddBtn from '@/components/common/AddBtn'
export default {
  name: 'custClue',
  components: {
    ListBoItem, SearchComponent, SearchBo, EmptyComponent, AddBtn, DialogAdd
    // , TotalComponent
  },
  data() {
    return {
      isEmpty: false,
      add_show: false,
      active: 0,
      boCount: {},
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      loading: false,
      finished: false,
      total: 0,
      list: [],
      show: false,
      type: 'add',
      showFilterPop: false,
      searchValue: '',
      custList: [],
      dictOptions: {
        boSourceOptions: this.$store.state.dictOptions.custSource || []
      },
      form: {
        boName: null
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        boStatus: '1',
        boFollowUserId: this.$store.state.user.user.userId
      }
    }
  },
  async created() {
    // 商机来源
    // await this.getDicts('crm_bo_source').then(res => {
    //   this.dictOptions.boSourceOptions = this.setDictToInt(res)
    // })
    // 商机状态
    await this.getDicts('crm_bo_status').then(res => {
      this.dictOptions.boStatusOptions = this.setDictToInt(res)
    })
    // 分配状态
    await this.getDicts('cms_distribute_status').then(res => {
      this.dictOptions.distributeStatusOptions = this.setDictToInt(res)
    })
    if (this.$route.query.custId) {
      this.queryParams.custId = this.$route.query.custId
    }
    await this.handleListStar()
    await this.queryCustList()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '商机管理-我的商机'
    },
    QueryReset() {
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.QueryReset()
      this.queryParams.boName = this.searchValue = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.getBoCount()
      this.list = []
      this.queryParams.pageNum = 1
      console.log(this.active)
      if (this.active != '3') {
        this.handleList()
      } else {
        this.handleListStar()
      }
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },

    toCustBlueDetails(item) {
      this.$router.push(`/scrm/custBo/detail/${item.boId}`)
    },
    showPicker(type) {
      this.picker.formKey = type
      if (this.options.custTypeOptions.length) {
        if (type === 'custType') {
          this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
        }
      } else {
        getDicts('crm_mycust_type').then(res => {
          this.options.custTypeOptions = res.data
          if (type === 'custType') {
            this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
          }
        })
      }
      this.picker.visible = true
    },
    addBo() {
      this.$router.push('/scrm/custBo/add')
    },
    handleAddBo() {
      this.add_show = true
    },
    handleAddBoCancel() {
      this.add_show = false
    },
    // 添加合同
    async addBoBeforeClose(val) {
      this.add_show = false
      await this.queryCustList()
    },
    onLoad() {
      this.handleList()
    },
    async handleList() {
      this.loading = true
      const res = await listBo(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    async handleListStar() {
      this.loading = true
      // const query = this.queryParams
      // query.boStatus = null
      const res = await listStar({ ...this.queryParams, boStatus: null })
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.total = res.total
        this.boCount.gzCount = res.total
        this.queryParams.pageNum += 1
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    getBoCount() {
      // const query = this.queryParams
      // query.boStatus = null
      getBusinessCount({ ...this.queryParams, boStatus: null }).then(res => {
        if (res.code === 200) {
          this.boCount = { ...this.boCount, ...res.data }
        }
      })
    },
    handleClick(val) {
      this.queryParams.boStatus = val + 1
      this.queryCustList()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.tab{
  padding-top: 100px;
  margin-bottom: -100px;
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
</style>
